<template>
  <div>
    <!-- 列表开始 -->
    <div class="BlockList">
      <div class="titles">Transformers Explorer</div>
      <div class="BlockList-W">
        <div class="box">
          <div class="tit1">
            What is the process of verifying <br />ownership of a contract
            address?
          </div>
          <div class="con1">
            <div class="title">
              The verification of contract address ownership is a<br />
              process designed to confirm the legitimate ownership of<br />
              a wallet address, establishing an association with a <br />smart
              contract (in this case, the "Transformers" smart <br />contract).
              This verification process ensures that the<br />
              contract is linked to the correct owner, enabling users to
              <br />manage token-related information associated with that<br />
              address.
            </div>
            <div class="title">
              Once users declare ownership of a particular address,<br />
              they can easily update relevant token information <br />without
              the need to sign a new message each time.
            </div>
            <div class="title">
              Ownership of multiple contract addresses can be added<br />
              under a single "Transformers" account.
            </div>
            <div class="title">
              <div style="color: #fff; margin-bottom: 8px">
                To verify ownership of an address, users need to follow these
                steps:
              </div>
              <div>
                <span class="icon"></span>
                Create an account on the "Transformers" browser.
              </div>
              <div>
                <span class="icon"></span>
                Sign each address once to verify its ownership.
              </div>
            </div>

            <div class="title">
              This process ensures that users can effectively manage contracts
              associated with these addresses, and it guarantees that only
              legitimate owners can perform relevant operations.
            </div>
          </div>
          <div class="tit1" style="margin-top: 20px">
            How to Verify Ownership?
          </div>
          <div class="con1">
            <div class="title">
              Users can verify ownership of their contract address and<br />
              link it to their Transformers account. Once this is<br />
              completed, they will gain permission to submit token<br />
              update requests only for the contract addresses they <br />own.
              This ensures that only legitimate owners of<br />
              contract addresses can update token information,<br />
              effectively securing the tokens. Please note that all <br />token
              update requests go through a review and approval<br />
              process before being published on our platform,<br />
              ensuring the integrity and accuracy of contract <br />information.
              These measures collectively provide users<br />
              with a sense of security and trust.
            </div>
            <div class="title" style="margin-bottom: 8px">
              <span style="color: #fff">
                Before declaring ownership of your contract address <br />and
                updating your token information, make sure to <br />perform the
                following steps:
              </span>
              <div style="margin-top: 8px">
                <span class="icon"></span>
                Ensure that the source code has been successfully<br />
                deployed on the Transformers blockchain.
              </div>
              <div>
                <span class="icon"></span>
                Confirm that your source code has been verified. If<br />
                your source code has not been verified yet, please<br />
                proceed with the verification process as soon as<br />
                possible.
              </div>
            </div>

            <div class="title">
              <span style="color: #fff">
                The steps to verify ownership of your contract address are as
                follows:
              </span>
            </div>
            <div class="title1">
              <div class="step">Step 1:</div>
              <div>Log in to your Transformers account.</div>
            </div>
            <div class="title1">
              <div class="step" style="margin-top: 10px;">Step 2:</div>
              <div>
                After logging in, click on the mailbox icon in the<br />
                upper right corner to access the address<br />
                verification page.
              </div>
            </div>
            <div class="img">
              <img src="../../../assets/m/logo/11.png" />
            </div>
            <div class="title1">
              <div class="step">Step 3:</div>
              <div>
                On the "Verified Addresses" page, you can<br />
                review the number of contract addresses you <br />have already
                verified and the operations you can<br />
                perform using these addresses. If you wish to <br />declare
                ownership of a new contract address, <br />click the [Add
                Address]​​ button located in the <br />upper right corner of the
                page.
              </div>
            </div>
            <div class="img">
              <img src="../../../assets/m/logo/22.png" />
            </div>
            <div class="title1">
              <div class="step">Step 4:</div>
              <div>
                Paste your contract address into the input box, <br />then
                click[Continue] .
              </div>
            </div>
            <div class="img">
              <img src="../../../assets/m/logo/33.png" />
            </div>
            <div class="title1">
              <div class="step">Step 5:</div>
              <div>
                You will see the option to sign the message<br />
                using your wallet interface. Click on [Scan and <br />sign] on
                the page, which will prompt a QR code<br />
                pop-up.
              </div>
            </div>
            <div class="img">
              <img src="../../../assets/m/logo/44.png" />
            </div>
            <div class="title1">
              <div class="step">Step 6:</div>
              <div>
                We use the Tree Wallet mobile wallet for<br />
                scanning the QR code and signing. After<br />
                successfully signing on your mobile device,<br />
                please click on [I have scanned and <br />signed] below.
              </div>
            </div>
            <div class="img">
              <img src="../../../assets/m/logo/55.png" />
            </div>
            <div class="title1">
              <div class="step">Step 7:</div>
              <div>
                You will see a confirmation indicating<br />
                successful contract verification. At this point,<br />
                you can use the verified contract address to <br />perform
                modifications to the<br />
                contract information!
              </div>
            </div>
            <div class="img">
              <img src="../../../assets/m/logo/66.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表结束 -->
  </div>
</template>

<script>
import axios from "axios";
import { GetBlockList } from "@/assets/server/api";
export default {
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
};
</script>

<style lang="less" scoped>
.BlockList {
  width: 100%;
  background: #13161b;
  .titles {
    padding-top: 120px;
    text-align: center;
    height: 75px;
    font-size: 52px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    color: #ffffff;
    line-height: 75px;
  }
  .BlockList-W {
    margin: 0 auto;
    width: 702px;
    height: 8657px;
    background: #000000;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    margin-top: 100px;
    .box {
      width: 654px;
      margin: 0 auto;
      padding-top: 24px;
      .tit1 {
        // height: 88px;
        font-size: 36px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 44px;
        text-align: left;
      }
      .con1 {
        margin-top: 16px;
        .title {
          font-size: 25px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 38px;
          word-spacing: -3px;
          margin-bottom: 20px;
          .icon {
            display: inline-block;
            width: 10px;
            height: 10px;
            background: #acacac;
            opacity: 1;
            border-radius: 50%;
            margin-right: 14px;
            margin-left: 7px;
          }
        }
        .title1 {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
          .step {
            // width: 90px;
            font-size: 26px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #02d28e;
            line-height: 38px;
            margin-bottom: 8px;
            // border: 1px solid red;
          }
          div {
            font-size: 25px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #898b8d;
            line-height: 38px;
            width: 562px;
            word-spacing: -2px;
          }
        }
        .img {
          width: 653px;
          margin-bottom: 50px;
          img {
            width: 653px;
          }
        }
      }
    }
  }
}
</style>
